/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'logout';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private authenticationService: AuthenticationService
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    return this.authenticationService.logout();
  }

  // Private Functions
}
